import React, { useState } from 'react'
import { supabase } from '../supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f8f7',
      fontFamily: 'Jost, sans-serif',
      padding: '24px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '340px',
        background: '#fff',
        borderRadius: '20px',
        border: '1px solid #c0e0dc',
        overflow: 'hidden',
        boxShadow: '0 4px 24px rgba(0,0,0,.08)'
      }}>
        <div style={{
          background: '#2d6973',
          padding: '32px 24px 24px',
          textAlign: 'center'
        }}>
          <div style={{
            fontFamily: 'Dancing Script, cursive',
            fontSize: '42px',
            fontWeight: '700',
            color: '#e8f8f6',
            lineHeight: 1,
            marginBottom: '6px'
          }}>
            Fired Up
          </div>
          <div style={{
            fontSize: '11px',
            fontWeight: '300',
            color: '#7bbfc9',
            letterSpacing: '.3px'
          }}>
            Track Your Shit
          </div>
        </div>

        <div style={{ padding: '24px' }}>
          {error && (
            <div style={{
              background: '#fff0f0',
              border: '1px solid #ffcccc',
              borderRadius: '10px',
              padding: '10px 12px',
              fontSize: '12px',
              color: '#cc4444',
              marginBottom: '16px'
            }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '12px' }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '500',
              letterSpacing: '.8px',
              textTransform: 'uppercase',
              color: '#5a8f96',
              marginBottom: '4px'
            }}>
              Email
            </div>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{
                width: '100%',
                background: '#f0f8f7',
                border: '1px solid #c0e0dc',
                borderRadius: '10px',
                padding: '10px 12px',
                fontSize: '13px',
                color: '#1a3a3e',
                outline: 'none',
                fontFamily: 'Jost, sans-serif',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '500',
              letterSpacing: '.8px',
              textTransform: 'uppercase',
              color: '#5a8f96',
              marginBottom: '4px'
            }}>
              Password
            </div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && handleLogin(e)}
              style={{
                width: '100%',
                background: '#f0f8f7',
                border: '1px solid #c0e0dc',
                borderRadius: '10px',
                padding: '10px 12px',
                fontSize: '13px',
                color: '#1a3a3e',
                outline: 'none',
                fontFamily: 'Jost, sans-serif',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? '#85cbcc' : '#2d6973',
              color: '#e8f8f6',
              border: 'none',
              borderRadius: '12px',
              padding: '12px',
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Jost, sans-serif',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background .2s'
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </div>
      </div>
    </div>
  )
}